const __WEBPACK_NAMESPACE_OBJECT__ = handleP2BLinks;